import { render, staticRenderFns } from "./YourStakeIcon.vue?vue&type=template&id=d098a6fa&"
import script from "./YourStakeIcon.vue?vue&type=script&lang=js&"
export * from "./YourStakeIcon.vue?vue&type=script&lang=js&"
import style0 from "./YourStakeIcon.vue?vue&type=style&index=0&id=d098a6fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports